"use client";

import { FC, PropsWithChildren, useEffect } from "react";
import Intercom from "@intercom/messenger-js-sdk";

import { useAuth } from "@auth/client-sdk-react";

import { PublicConfig } from "../config/public";

import { DixaBot } from "./DixaBot";

const displayIntercomChat = (
  loggedIn: boolean | undefined,
  id?: string | undefined,
  email?: string | undefined,
) => {
  if (loggedIn) {
    Intercom({
      app_id: "tis5m73e",
      region: "eu",
      user_id: id,
      email,
    });

    return;
  }

  Intercom({
    app_id: "tis5m73e",
    region: "eu",
  });
};

export const ChatBot: FC<PropsWithChildren> = () => {

  const { loggedIn, id, email } = useAuth();
  const useIntercomChat = PublicConfig.ANIKIN_ENVIRONMENT === "stg";

  useEffect(() => {
    if (useIntercomChat) {
      document.body.dataset.chatbot = "intercom";
    } else {
      document.body.dataset.chatbot = "elevio";
    }
  }, [ useIntercomChat, loggedIn ]);

  return (
    <>
      { useIntercomChat && displayIntercomChat(loggedIn, id, email) }
      { !useIntercomChat && <DixaBot/> }
    </>
  );
};
